import React from 'react';
import { useModal } from '@/core/hooks/useModal';
import Icon from '@/components/atoms/UI/Icon/Icon';
import Button from '@/components/atoms/UI/buttons/Button';
import { useTranslation } from 'react-i18next';
import { AppDispatch } from '@/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTES } from '@/constants/urls';
import Grid from '@/components/molecules/Grid';
import { ResultH3 } from '@/pages/result/styles';
import CopyTextInside from '@/components/features/CopyTextInside/CopyTextInside';
import ShareButtons from '@/components/features/ShareButtons/ShareButtons';
import { selectAttemptKey } from '@/store/selectors/selectAttemptKey';
import A from '@/components/atoms/UI/links/A';
import { selectAttemptUrl } from '@/store/selectors/selectAttemptUrl';

const SharePageButton: React.FC = () => {
	const dispatch: AppDispatch = useDispatch();
	const { show: showShareModal, RenderModal, hide } = useModal();
	const resultAttemptLink = useSelector(selectAttemptUrl);

	const { t } = useTranslation();
	const text_link = t('result.link' as string);
	const text_share_title = t('result.share' as string);
	const text_share = t('share' as string);

	const handleShareButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		showShareModal();
	};

	return (
		<>
			<RenderModal>
				<Grid col='1' gap='4'>
					<Grid col='1' gap='2'>
						<ResultH3>{text_link}:</ResultH3>
						<CopyTextInside><A href={resultAttemptLink}>{resultAttemptLink}</A></CopyTextInside>
					</Grid>

					<Grid col='1' gap='2'>
						<ResultH3>{text_share_title}:</ResultH3>
						<ShareButtons url={resultAttemptLink}/>
					</Grid>
				</Grid>
			</RenderModal>

			<Button light autoWidth onClick={handleShareButtonClick}>
				<Icon name={'Share'} small />
				{text_share}
			</Button>

		</>
	);
};

export default SharePageButton;
